import $ from 'jquery'
import slick from 'slick-carousel'
import * as project from './functions'
import * as anim from './animation'
import './polyfill'
import './facet'

$(window).on('load', function() {
  project.wrapTrademarkSymbol()

  if ($('.slider-init').length > 0) {
    $('.slider-init:not(.slick-initialized)').each(function() {
      project.setupSlideshow($(this), $(this).data('slick'), $(this).data('slides'))
    })
  }

  project.lazyLoad()
  project.smoothScroll()
  project.scrollToAnchor()
  project.menuOverlay()
  project.setupSearchOverlay()
  project.setupMegaMenu()
  project.accordionToggle()
  project.setupModalVideo()
  project.setupJqueryModal()
  // project.recipeUsedProduct()
  project.getUploadFile()
  project.sliderChangeTitles('.section--common-promoted-recipes','.preview__title','.section__slider-wrapper')
  project.populateCatalogueField()
  anim.titleAnimation()
  anim.animationMenu()
  project.urFormLabelToggle()
  project.wooCartProductLinkTarget()

  const bodyClasses = $('body').attr("class").split(/\s+/)

  $.each(bodyClasses, function(key, value) {
    switch(value) {
      case "home":
        $('.section__video-wrapper').addClass('show')
        break
      case "blog":
        project.blogDraggableOverflow()
        break
      case "page-template-archive-brand":
        project.archiveBrandsChangeColor()
        project.sliderChangeTitles('.section--archive-brand-technology','.section__slide-title','.section__slider-wrapper')
        break
      case "page-template-about":
        project.sliderChangeTitles('.section--about-slider','.section__slide-title','.section__slider-wrapper')
        project.sliderChangeTitles('.section--about-story','.section__title-mobile','.section__story-container')
        project.aboutSplitChars()
        project.aboutChangeColor()
        break
      case "page-template-form":
        anim.pageFormPinHeader()
        project.workAutoFillForm()
        project.contactUsAutoFillForm()
        project.modalFormDetectScroll()
        break
      case "page-template-archive-documents":
        anim.archiveDocumentsPinHeader()
        break
      case "category":
        anim.archivePinPost()
        project.sliderChangeTitles('.section--archive-post-promoted','.preview__title','.section__slider-wrapper')
        break
      case "page-template-horeca":
        anim.archivePinPost()
        break
      case "single-product":
        anim.productPinHeader()
        project.openSocialShare()
        project.checkForm()
        project.wooCloseNotice()
        break
      case "post-type-archive-product":
        // anim.postArchivePinHeader()
        project.appendSearchArchive()
        project.wooCloseNotice()
        break
      case "post-type-archive-recipe":
        // anim.postArchivePinHeader()
        project.appendSearchArchive()
        break
      case "single-recipe":
        project.openSocialShare()
        break
      case "single-open_position":
        project.openSocialShare()
        anim.openPositionPinTool()
        break
      case "single-tribe_events":
        anim.eventPinTool()
        break
      case "page-template-work":
        anim.workHeroAnim()
        anim.setupWorkAnimation()
        project.workVideoControls()
        break
      case "page-template-work-archive":
        anim.workHeroAnim()
        project.workVideoControls()
        break
      case "single-post":
        project.sliderChangeTitles('.post__gallery-caption','.post__slide-caption','.post__repeater')
        anim.postPinHeader()
        break
      default:
        $('#loader').fadeOut(500)
    }
  })
})

$(document).on('facetwp-refresh', function() {
  FWP.enable_scroll = FWP.soft_refresh == true
  // project.lazyLoad()
  if (FWP.enable_scroll == true) $('html, body').animate({ scrollTop: 0 }, 500)
})

$(document).on('facetwp-loaded', function() {
  if (FWP.enable_scroll == true) $('html, body').animate({ scrollTop: 0 }, 500)
  project.wrapTrademarkSymbol()
  project.lazyLoad()
})



// WEBPACK FOOTER //
// ./src/js/main.js